import React from 'react'
import { Outlet } from 'react-router-dom'

import { StatusChecksSearchProvider } from 'components/status-checks/StatusChecksSearchState'
import { ObservabilityToolAuthenticationProvider } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { StatusCheckExternalIntegrationsProvider } from 'context/status-checks/StatusCheckExternalIntegrationsContext'
import { StatusChecksProvider } from 'context/status-checks/StatusChecksContext'

export const StatusChecksIndexRoutesWrapper: React.FC = () => {
  return (
    <StatusChecksSearchProvider>
      <StatusChecksProvider>
        <StatusCheckExternalIntegrationsProvider>
          <ObservabilityToolAuthenticationProvider>
            <Outlet />
          </ObservabilityToolAuthenticationProvider>
        </StatusCheckExternalIntegrationsProvider>
      </StatusChecksProvider>
    </StatusChecksSearchProvider>
  )
}
